<template>
  <router-view></router-view>
</template>

<script>
import Layout from "./layout/index.vue";
export default {
  name: "App",
  components: {
    Layout,
  },
}
</script>

<style lang="scss">
@import "https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap";
@import "./assets/scss/main.scss";
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Poppins", sans-serif;
}
</style>
